import dayjs, { monthDisplayFormat } from '~libs/dayjs';

import { Column } from '~components/table-view';
import StatementActions from '~support-at-home/components/claims/StatementActions';

import StatusBadge from './StatusBadge';

export const columns: Column[] = [
  {
    id: 'reference',
    header: 'Reference',
    type: 'text',
  },
  {
    id: 'full_name',
    header: 'Client',
    type: 'text',
    deriveValue: (row) => row.client?.full_name,
  },
  {
    id: 'delivery_preference',
    header: 'Delivery Preference',
    type: 'text',
    deriveValue: (row) => row.client?.statement_delivery?.name || '',
  },
  {
    id: 'start_date',
    header: 'Month',
    type: 'text',
    deriveValue(row) {
      return dayjs(row.start_date).format(monthDisplayFormat);
    },
  },
  {
    id: 'status',
    header: 'Status',
    type: 'custom',
    component: StatusBadge,
  },
  {
    id: 'created_at',
    header: 'Created At',
    type: 'date',
  },
  {
    id: 'actions',
    header: 'Actions',
    type: 'custom',
    style: { width: '150px' },
    component: StatementActions,
  },
];
